import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { TableCell, TableHead, TableRow, TableSortLabel, withStyles, lighten, Paper, TableContainer, Table, TableBody, Tooltip, IconButton, Popover, TablePagination } from '@material-ui/core';
import moment from 'moment';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { REMOVE_KEY } from '../../core/handlers.actions';

const styles = (theme: any) => ({
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute' as any,
        top: 20,
    },
    toolBarRoot: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.primary.main,
                backgroundColor: lighten(theme.palette.primary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.primary.dark,
            },
    title: { flex: '1 1 100%' },
    tableRoot: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    tableVisuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute' as any,
        top: 20,
        width: 1,
    },
    actionRow: {
        display: 'inline-flex' as any
    },
    okButton: {
        color: 'green'
    },
    xButton: {
        color: 'red'
    },
    search: {
        position: 'relative' as any,
        borderRadius: theme.shape.borderRadius,
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(1),
            width: 'auto',
        },
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute' as any,
        pointerEvents: 'none' as any,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
                width: '20ch',
            },
        },
    }
});

interface Props {
    keys: any;
    classes: any;
    deleteKey: (id: string) => void;
    editKey: (id: string) => void;
}

interface State {
    headers: any;
    numSelected: number;
    order: Order;
    orderBy: string;
    page: number;
    dense: boolean;
    rowsPerPage: number;
    rows: any;
    popoverElement: any;
    popoverOpen: boolean;
    popevercurrentItem: any;
    filtered: any;
}

interface HeadCell {
    disablePadding: boolean;
    id: any;
    label: string;
    numeric: boolean;
}

const headCells: HeadCell[] = [
    { id: 'name', disablePadding: false, label: 'Name', numeric: false },
    { id: 'key', disablePadding: false, label: 'API Key', numeric: false },
    { id: 'status', disablePadding: false, label: 'Status', numeric: false },
    { id: 'createdAt', disablePadding: false, label: 'Created At', numeric: false },
    { id: 'updatedAt', disablePadding: false, label: 'Updated At', numeric: false }
];

type Order = 'asc' | 'desc';

class KeyTable extends Component<Props, State> {
    state: State = {
        headers: headCells,
        numSelected: 0,
        orderBy: 'name',
        order: 'asc',
        page: 0,
        dense: false,
        rowsPerPage: 5,
        rows: [],
        popoverElement: undefined,
        popoverOpen: false,
        popevercurrentItem: '',
        filtered: []
    }

    constructor(props: Props) {
        super(props);
        this.createTableHeader = this.createTableHeader.bind(this);
        this.descendingComparator = this.descendingComparator.bind(this);
        this.getComparator = this.getComparator.bind(this);
        this.stableSort = this.stableSort.bind(this);
        this.handleRequestSort = this.handleRequestSort.bind(this);
        this.pagerHandler = this.pagerHandler.bind(this);
        this.rowsPerPagehandler = this.rowsPerPagehandler.bind(this);
        this.handleOpenPopover = this.handleOpenPopover.bind(this);
        this.handleClosePopover = this.handleClosePopover.bind(this);
        this.renderHtml = this.renderHtml.bind(this);
        this.filter = this.filter.bind(this);
    }

    public pagerHandler(event: unknown, newPage: number) {
        this.setState({ ...this.state, page: newPage });
    }

    public rowsPerPagehandler(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({ ...this.state, page: 0, rowsPerPage: parseInt(event.target.value, 10) });
    }

    public handleOpenPopover(event: React.MouseEvent<HTMLButtonElement>) {
        const currentEventId = event.currentTarget.getAttribute('aria-describedby');
        this.setState({ ...this.state, popevercurrentItem: currentEventId, popoverElement: event.currentTarget, popoverOpen: Boolean(event.currentTarget) });
    }

    public handleClosePopover() {
        this.setState({ ...this.state, popoverElement: null, popoverOpen: false });
    }

    public renderHtml(data: any) {
        return { __html: data };
    }

    public handleRequestSort(event: React.MouseEvent<unknown>, property: any) {
        const { orderBy, order } = this.state;
        const isAsc = orderBy === property && order === 'asc';
        this.setState({ ...this.state, order: isAsc ? 'desc' : 'asc', orderBy: property });
    }

    public descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
        if (b[orderBy] < a[orderBy]) return -1;
        if (b[orderBy] > a[orderBy]) return 1;
        return 0;
    }

    public stableSort<T>(array: T[], comparator: (a: T, b: T) => number) {
        const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    }

    public getComparator<Key extends keyof any>(order: Order, orderBy: Key): (a: { [key in Key]: number | string }, b: { [key in Key]: number | string }) => number {
        return order === 'desc' ? (a, b) => this.descendingComparator(a, b, orderBy) : (a, b) => -this.descendingComparator(a, b, orderBy);
    }

    public filter(e: any) {
        const { keys } = this.props;
        const filtered = keys.filter((item: any) => item.name.toLowerCase().includes(e?.target.value));
        this.setState({ ...this.state, filtered: filtered });
    }

    public createTableHeader() {
        const { headers, orderBy, order } = this.state;
        const { classes } = this.props;
        return (
            <TableHead>
                <TableRow>
                    {headers.map((headCell: any) => (
                        <TableCell
                            key={headCell.id}
                            align={headCell.numeric ? 'right' : 'left'}
                            padding={headCell.disablePadding ? 'none' : 'default'}
                            sortDirection={orderBy === headCell.id ? order : false}>

                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={(e) => this.handleRequestSort(e, headCell.id)}>
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <span className={classes.visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </span>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    ))}
                    <TableCell
                        key={'actions'}
                        align={'left'}
                        padding={'none'}>
                        Actions
                    </TableCell>
                </TableRow>
            </TableHead>
        );
    }

    public render() {
        const { order, orderBy, page, dense, rowsPerPage, popoverOpen, popoverElement, popevercurrentItem, filtered } = this.state;
        const { classes, editKey, deleteKey, keys } = this.props;

        return (
            <div className={classes.tableRoot}>
                <Paper className={classes.paper}>
                    <TableContainer>
                        <Table
                            className={classes.table}
                            aria-labelledby="tableTitle"
                            size={dense ? 'small' : 'medium'}
                            aria-label="enhanced table">
                            {this.createTableHeader()}
                            <TableBody>
                                {this.stableSort((filtered.length === 0) ? keys : filtered, this.getComparator(order, orderBy))
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((key: any, index: number) => {
                                        const labelId = `enhanced-table-checkbox-${index}`;
                                        return (
                                            <TableRow
                                                hover
                                                tabIndex={-1}
                                                key={`row-${index}`}>
                                                <TableCell id={labelId} scope="row">{key.name}</TableCell>
                                                <TableCell align="left">{key.key}</TableCell>
                                                <TableCell align="left">{key.isActive ? 'Active' : 'Inactive'}</TableCell>
                                                <TableCell align="left" >{moment(key.createdDate).format('ll')}</TableCell>
                                                <TableCell align="left" >{moment(key.updatedAt).format('ll')}</TableCell>
                                                <TableCell align="left">
                                                    <Tooltip title="More Actions">
                                                        <IconButton aria-label="More Actions" aria-describedby={key._id} onClick={this.handleOpenPopover}>
                                                            <MoreVertIcon className={classes.xButton} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                <Popover
                                    id='simple-popover'
                                    open={popoverOpen}
                                    anchorEl={popoverElement}
                                    onClose={this.handleClosePopover}
                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                                    transformOrigin={{ vertical: 'top', horizontal: 'center' }}>
                                    
                                    <Tooltip title="Edit Key">
                                        <IconButton aria-label="Edit Key" onClick={() => { editKey(popevercurrentItem); this.handleClosePopover(); }}>
                                            <EditIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Delete Key">
                                        <IconButton aria-label="Delete Key" onClick={() => { deleteKey(popevercurrentItem); this.handleClosePopover(); }}>
                                            <DeleteIcon className={classes.xButton} />
                                        </IconButton>
                                    </Tooltip>
                                </Popover>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 15, 25]}
                        component="div"
                        count={(filtered.length === 0) ? keys.length : filtered.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onChangePage={this.pagerHandler}
                        onChangeRowsPerPage={this.rowsPerPagehandler} />
                </Paper>
            </div>
        );
    }
}


const mapProps = (app: any) => ({ keys: app.rootReducer.keys });
const mapDispatch = (dispatch:Dispatch) => ({
    deleteKey: (id:string) => dispatch({type: REMOVE_KEY, payload: id}) 
})
export default connect(mapProps, mapDispatch)(withStyles(styles)(KeyTable));